import React from 'react';

import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import CompanyDetailsFormSection from 'buyside/components/presentation/JobVaultSubmission/CompanyDetailsFormSection/CompanyDetailsFormSection';
import InvestmentMandate from 'buyside/components/presentation/JobVaultSubmission/InvestmentMandate/InvestmentMandate';
import PositionInvestmentMandate from 'buyside/components/presentation/JobVaultSubmission/InvestmentMandate/PositionInvestmentMandate';
import YearsOfExperience from 'buyside/components/presentation/JobVaultSubmission/YearsOfExperience/yearsOfExperience';
import FirmExperience from 'buyside/components/presentation/JobVaultSubmission/FirmExperience/FirmExperience';
import DegreesAndCertifications from 'buyside/components/presentation/JobVaultSubmission/DegreesAndCertifications/DegreesAndCertifications';
import {
  GPASelect,
  SATSelect,
  ACTSelect
} from 'buyside/components/presentation/JobVaultSubmission/MaxSelect/MaxSelect';
import CoverLetterSection from 'buyside/components/presentation/JobVaultSubmission/CoverLetterSection/CoverLetterSection';
import JobDetailsSection from 'buyside/components/presentation/JobVaultSubmission/JobDetailsSection/JobDetailsSection';

import styles from './JobVaultSubmissionFormStyles';

const JobVaultSubmissionForm = ({
  isMobile,
  currentUser,
  handleSubmit,
  isSubmitting,
  ...props
}) => {
  const {
    mostRecentEmployer: { employer }
  } = currentUser;

  return (
    <form onSubmit={handleSubmit}>
      <div className={`${styles.spacing} ${isMobile ? '' : styles.container}`}>
        <h4 className={styles.title}>Company Details</h4>
        <CompanyDetailsFormSection isMobile={isMobile} employer={employer} {...props} />

        <h4 className={styles.title}>Company Investment Mandate</h4>
        <p>Select the types of securities your firm invests in.</p>

        <InvestmentMandate isMobile={isMobile} employer={employer} {...props} />

        <h4 className={styles.title}>Position Investment Mandate</h4>
        <p>
          Select the types of securities the successful candidate will invest in as an employee of
          your firm.
        </p>

        <PositionInvestmentMandate isMobile={isMobile} {...props} />

        <h4 className={styles.title}>Minimum Qualifications (Optional)</h4>
        <p>
          <strong>Note:</strong> Candidates will be prevented from applying to this position if they
          do not meet the criteria you specify below. You will be able to filter applicants by the
          same criteria after they've applied
        </p>

        <h4 className={styles.subtitle}>Years Of Experience</h4>
        <p>Specify the acceptable range of a candidate's years of experience.</p>

        <YearsOfExperience {...props} />

        <h4 className={styles.subtitle}>Firm Experience</h4>

        <p>
          Candidates must have experience working for{' '}
          <strong className={styles.emphasis}>at least</strong> one of the following:
        </p>

        <div className={styles.checkboxStyles} data-testid="firmExperience">
          <FirmExperience isMobile={isMobile} {...props} />
        </div>

        <h4 className={styles.subtitle}>Degrees/Certifications</h4>

        <p>
          Candidates must have <strong className={styles.emphasis}>at least</strong> one of the
          following:
        </p>

        <div className={styles.checkboxStyles}>
          <DegreesAndCertifications isMobile={isMobile} {...props} />
        </div>

        <h4 className={styles.subtitle}>Minimum Undergraduate GPA</h4>

        <p>Indicate candidates' minimum GPA and its corresponding scale</p>

        <GPASelect isMobile={isMobile} {...props} />

        <h4 className={styles.subtitle}>Minimum SAT Score</h4>

        <p>
          Indicate the minimum SAT score required to apply to this position. Please note candidates
          who have never taken the SAT may still apply to this job (most international applicants
          have never taken US standardized exams).
        </p>

        <p className={styles.linkText}>
          Please see this{' '}
          <a
            href="https://blog.prepscholar.com/act-to-sat-conversion"
            target="_blank"
            rel="noopener noreferrer"
          >
            link
          </a>{' '}
          to compare the SAT and ACT scores and convert between them.
        </p>

        <SATSelect isMobile={isMobile} {...props} />

        <h4 className={styles.subtitle}>Minimum ACT Score</h4>

        <p>
          Indicate the minimum ACT score required to apply to this position. Please note candidates
          who have never taken the ACT may still apply to this job (most international applicants
          have never taken US standardized exams). Please see this link to compare the SAT and ACT
          scores and convert between them.
        </p>

        <p className={styles.linkText}>
          Please see this{' '}
          <a
            href="https://blog.prepscholar.com/act-to-sat-conversion"
            target="_blank"
            rel="noopener noreferrer"
          >
            link
          </a>{' '}
          to compare the SAT and ACT scores and convert between them.
        </p>

        <ACTSelect isMobile={isMobile} {...props} />

        <h4 className={styles.subtitle}>Cover Letter</h4>

        <p>Specify if an applicant's cover letter is required, optional, or unwanted.</p>

        <CoverLetterSection {...props} />

        <h4 className={styles.title}>Position Details</h4>

        <JobDetailsSection isMobile={isMobile} {...props} />

        <div className={`${styles.submitButton} ${isMobile ? styles.buttonResponsive : ''}`}>
          <Button
            type={BUTTON_TYPES.PRIMARY}
            text={`${isSubmitting ? 'Submitting...' : 'Submit New Job Posting'}`}
            isLoading={isSubmitting}
          />
        </div>
      </div>
    </form>
  );
};

export default JobVaultSubmissionForm;
